<em [class]="classIcon"></em>
